(() => {
  const closeMenu = (header, returnFocus = false) => {
    const toggle = header?.querySelector('[data-menu-toggle]');
    header?.querySelector('.navigation')?.classList.remove('open');
    toggle?.setAttribute('aria-expanded', 'false');
    header?.querySelectorAll('details[open]').forEach(details => details.removeAttribute('open'));
    if (returnFocus) toggle?.focus();
  };
  document.addEventListener('click', event => {
    const toggle = event.target.closest('[data-menu-toggle]');
    if (toggle) {
      const header = toggle.closest('.header');
      const nav = header?.querySelector('.navigation');
      const open = toggle.getAttribute('aria-expanded') !== 'true';
      toggle.setAttribute('aria-expanded', String(open));
      nav?.classList.toggle('open', open);
    } else if (event.target.closest('.fh-header-wrapper .navigation a')) {
      closeMenu(event.target.closest('.header'));
    } else if (!event.target.closest('.fh-header-wrapper .header')) {
      document.querySelectorAll('.fh-header-wrapper .header').forEach(header => closeMenu(header));
    }
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.fh-header-wrapper .header').forEach(header => {
      const focused = header.contains(document.activeElement);
      closeMenu(header, focused && header.querySelector('[data-menu-toggle]')?.getAttribute('aria-expanded') === 'true');
    });
  });
  matchMedia('(max-width: 1000px)').addEventListener('change', () => {
    document.querySelectorAll('.fh-header-wrapper .header').forEach(header => closeMenu(header));
  });
})();
